/**
 * Scroll Separator Animation
 * Rotates the icon based on scroll position.
 */

document.addEventListener('DOMContentLoaded', () => {
	// Register GSAP Plugin if not already (it should be global)
	gsap.registerPlugin(ScrollTrigger);

	const separators = document.querySelectorAll('.osmerova-scroll-separator');

	separators.forEach((separator) => {
		const icon = separator.querySelector('.separator-icon');

		if (icon) {
			// We want the rotation to be continuous as the user scrolls the PAGE.
			// "Clockwise on scroll down" -> Positive rotation.

			// Approach: Link rotation to the global scroll progress of the page?
			// Or just relative to when the separator is in view?
			// Usually, these separators are just small parts of the page.
			// If we want it to rotate *whenever* the user scrolls, regardless of where the separator is (as long as it's visible?),
			// or just map the rotation to the scroll position of the entire body.

			// Let's map it to the entire body scroll for a consistent "gear" feel.
			// This means as you scroll down 1000px, it rotates X degrees.

			gsap.to(icon, {
				rotation: 360 * 3, // Rotate 5 times over the course of the page
				ease: 'none',
				scrollTrigger: {
					trigger: document.body,
					start: 'top top',
					end: 'bottom bottom',
					scrub: 1, // Smooth scrubbing
					// markers: true // Debug
				}
			});
		}
	});
});
